import React from 'react'

import { Suspense } from '~/components/elements/Suspense'
import { useLogEventOnMount } from '~/hooks/useLogEventOnMount'

import { BrandUserList } from './components/BrandUserList'
import { Dialogs } from './components/Dialogs'
import { useMainQuery } from './hooks'

export const BrandAccountUserListPage = () => {
  const { isLoading } = useMainQuery()

  useLogEventOnMount('Access to userlist')

  return (
    <Suspense loading={isLoading}>
      <BrandUserList />

      <Dialogs />
    </Suspense>
  )
}
